import { env } from '@/env';
import PusherClient from 'pusher-js';

let pusherInstance: PusherClient | null = null;

/**
 * Client-side Pusher helper — returns a singleton instance.
 */
export const getPusherClient = () => {
  if (pusherInstance) return pusherInstance;

  const key = env.NEXT_PUBLIC_SOKETI_APP_KEY;
  const host = env.NEXT_PUBLIC_SOKETI_HOST;
  const port = env.NEXT_PUBLIC_SOKETI_PORT;
  const useTLS = env.NEXT_PUBLIC_SOKETI_USE_TLS === 'true';

  if (!key || !host || !port) {
    console.error('Soketi configuration is missing (key, host, or port)');
    return null;
  }

  const pusher = new PusherClient(key, {
    wsHost: host,
    wsPort: Number.parseInt(port),
    wssPort: Number.parseInt(port),
    forceTLS: useTLS,
    enabledTransports: ['ws', 'wss'],
    cluster: '',
    channelAuthorization: {
      endpoint: '/api/pusher/auth',
      transport: 'ajax',
    },
  });

  pusher.connection.bind('connected', () => {
    console.log('✅ Soketi connected');
  });

  pusher.connection.bind('error', (err: any) => {
    console.error('❌ Soketi connection error:', err);
  });

  pusherInstance = pusher;
  return pusher;
};
